const RESTORE_KEY = 'clientsListRestoreScroll'
const SCROLL_Y_KEY = 'clientsListScrollY'

export function markClientsListScrollIntent() {
  try {
    sessionStorage.setItem(SCROLL_Y_KEY, String(window.scrollY))
    sessionStorage.setItem(RESTORE_KEY, '1')
  } catch (_) {
    /* ignore */
  }
}

/** Call when opening Clients from the sidebar (or any intentional list entry) — no scroll restore. */
export function clearClientsListScrollIntent() {
  try {
    sessionStorage.removeItem(RESTORE_KEY)
    sessionStorage.removeItem(SCROLL_Y_KEY)
  } catch (_) {
    /* ignore */
  }
}

/**
 * One-shot window scroll that ignores global `html { scroll-behavior: smooth }`.
 */
export function scrollWindowYInstant(y) {
  const top = Math.max(0, Math.floor(Number(y)) || 0)
  const html = document.documentElement
  const prev = html.style.scrollBehavior
  html.style.scrollBehavior = 'auto'
  window.scrollTo(0, top)
  html.style.scrollBehavior = prev
}

/**
 * If the user opened a client card from the list, return saved scroll Y and clear session keys.
 * Otherwise return null.
 */
export function takeClientsListScrollRestoreY() {
  try {
    if (sessionStorage.getItem(RESTORE_KEY) !== '1') return null
    sessionStorage.removeItem(RESTORE_KEY)
    const raw = sessionStorage.getItem(SCROLL_Y_KEY)
    sessionStorage.removeItem(SCROLL_Y_KEY)
    if (raw == null) return null
    const y = parseInt(raw, 10)
    return Number.isNaN(y) ? null : y
  } catch (_) {
    return null
  }
}
